<template>
  <div class="misc-wrapper">
    <RouterLink class="brand-logo">
      <vona-logo />
      <h2 class="brand-text text-primary ml-1">
        {{ getAssociation }}
      </h2>
    </RouterLink>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Não Autorizado🔒</h2>
        <p class="mb-2">Você não tem permissão para acessar essa página.</p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="loginRoute()"
        >
          Voltar para a página principal
        </b-button>
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { useAuth } from "@/services";
import { getHomeRouteForLoggedInUser } from "@/services/utils";
import store from "@/store/index";
import VonaLogo from "@core/layouts/components/Logo.vue";
import { BButton, BImg } from "bootstrap-vue";
import { RouterLink } from "vue-router";

export default {
  components: {
    RouterLink,
    BImg,
    BButton,
    VonaLogo,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/not-authorized.svg"),
    };
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(
        localStorage.getItem(useAuth.serviceConfig.storageUserDataName)
      );
      return getHomeRouteForLoggedInUser(user ? user.role : "");
    },
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/not-authorized-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
    getAssociation() {
      return localStorage.getItem("domain") || "Vona";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
